<template>

</template>

<script>
import { PageHeaderWrapper } from '@/components/ProLayout'

export default {
  name: 'Index',
  components: {
    PageHeaderWrapper
  },
  data () {
    return {

    }
  },
  computed: {

  },
  created () {

  },
  mounted () {
  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
  @import "./index.less";

</style>
